<template>
  <div class="flex w-full loginWrapper">
    <CustomToast />
    <div class="w-[48%] pl-12 py-9 bg-[#FCF9F4] min-h-screen">
      <img src="@/assets/svg/navlogo.svg" alt="" />
      <div class="mt-20 illustration">
        <img src="@/assets/svg/call-back.svg" alt="" />
      </div>
      <div class="text mt-[15px]">
        <p class="mb-4 text-3xl font-semibold font-sfPro">
          {{ $t("login.leftHeader") }}
        </p>
        <p class="font-medium text-gray-700 font-sfPro">
          {{ $t("login.leftText") }}
        </p>
      </div>
    </div>
    <div class="w-full right">
      <div class="wrapper pt-16 pl-32 pr-[292px]">
        <div class="w-40 mb-5">
          <Button
            class="bg-[#000]"
            :theme="'greyOutline'"
            :size="'small'"
            :disabled="loading"
            :radius="'small'"
            @handleClick="$router.push('/login')"
          >
            <img src="@/assets/svg/arrow-left-circle.svg" alt="" />
            <p class="text-gray-700 font-medium text-[16px]">Back to login</p>
          </Button>
        </div>
        <div class="login-main">
          <div class="text">
            <p class="mb-3 text-5xl font-millik">
              {{ translateText("common.emailConfirmation") }}
            </p>
            <p class="text-gray-700 font-sfPro space-x-2 flex-items-center">
              <span v-if="!emailSent">
                {{ translateText("common.confirmationLoading") }}</span
              >
              <span v-else> {{ translateText("common.checkEmail") }}</span>
              <ClipLoaderVue
                v-if="loading"
                color="black"
                :size="15"
                class="mt-[-5px]"
              />
            </p>
            <!-- <p class="mb-5 font-semibold text-gray-700 font-sfPro">
              {{ $t("callBack.rightSubText.2") }}
            </p>
            <p class="text-gray-500 font-sfPro">
              {{ $t("callBack.rightSubText.3") }}
            </p> -->
          </div>
          <!-- <div class="inputs w-[486px] mt-4">
            <div
              class="contacts bg-inputGrey-300 rounded-xl py-2.5 px-5 mb-3 flex w-[408px] text-gray-600 font-semibold"
              v-for="contact in contacts"
              :key="contact.name"
            >
              <img src="@/assets/svg/call-calling.svg" alt="" class="mr-4" />
              <div class="px-5 border-r border-gray-600">
                {{ contact.phone }}
              </div>
              <div class="px-5">{{ contact.name }}</div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div class="flex justify-end px-24 mt-24 faq">
        <img src="@/assets/svg/faq.svg" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/store/Auth";
import EpumpInputVue from "@/components/UI/Inputs/EpumpInput.vue";
import Button from "@/components/UI/Buttons/Button.vue";
import { successToast, translateText } from "@/core/helpers/utility";
import { mapActions } from "pinia";

export default {
  components: {
    EpumpInputVue,
    Button,
  },
  computed: {
    isErrorEmpty() {
      return Object.keys(this.errors).length === 0;
    },
  },
  data() {
    return {
      emailSent: false,
      username: "",
      translateText,
      errors: {},
      loading: false,
      contacts: [
        { phone: "+234 913 148 999", name: "OLA" },
        { phone: "+234 913 148 999", name: "FOLAKE" },
      ],
    };
  },
  mounted() {
    if (this.$route.query?.userId) this.confirmEmail();
  },
  methods: {
    setUsername(e) {
      this.username = e.target.value;
    },
    ...mapActions(() => useAuthStore(), ["_confirmEmail"]),
    confirmEmail() {
      this.loading = true;
      const { userId, code } = this.$route.query ?? {};
      const data = {
        userId,
        code,
      };
      this._confirmEmail(data)
        .then((res) => {
          if (res) this.emailSent = true;
          successToast(translateText("common.checkEmail"));
        })
        .catch((error) => {
          this.emailSent = false;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
